import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { ACRouterLink } from 'academy-common-lib/components/ACRouterLink';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import UsageTracker from '../../../../utils/UsageTracker';
import RoundedCertificationBadge from '../RoundedCertificationBadge';
import { CERTIFICATIONS_INDEX_PATH } from '../../constants/routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertificationLink = ({
  certificationIconUrl,
  certificationId,
  certificationName,
  showIcon = true,
  truncate = true,
  position
}) => {
  const {
    isTablet
  } = useMediaQuery();
  const handleCertificationClick = () => {
    UsageTracker.track('teamInteraction', {
      action: 'certification-link-click',
      contentId: certificationId.toString(),
      contentName: certificationName,
      position
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "400",
    children: [showIcon && !isTablet && /*#__PURE__*/_jsx(Box, {
      shrink: 0,
      children: /*#__PURE__*/_jsx(RoundedCertificationBadge, {
        iconUrl: certificationIconUrl,
        size: "700"
      })
    }), /*#__PURE__*/_jsx(ACRouterLink, {
      onClick: handleCertificationClick,
      to: `${CERTIFICATIONS_INDEX_PATH}/${certificationId}`,
      children: truncate ? /*#__PURE__*/_jsx(TruncateString, {
        children: certificationName
      }) : certificationName
    })]
  });
};
export default CertificationLink;